<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" :tip="loadTip">
      <a-form class="ant-advanced-search-form">
        <a-row class="searchrow nobottom-border width-style-auto" style="padding-bottom: 0px" >
          <a-form-item :colon="false" label="单据号">
            <a-input v-model="record.docNo" :disabled="true" >
            </a-input>
          </a-form-item>
          <a-form-item :colon="false" label="供应商">
            <a-select v-model="record.supplierId">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.suppliers" :key="item.id" :value="item.id">
                {{item.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :colon="false" label="制单日期">
            <a-date-picker style="width: 120px"
                           v-model="record.makeTime"
                           valueFormat="YYYY-MM-DD"
            />
          </a-form-item>
        </a-row>
      </a-form>
      <a-row class="form-row" style="margin-top:10px;padding-top: 20px">
        <div class="left-span" style="width: 36%">
          <a-select style="width: 80%"
                    show-search
                    placeholder="请输入药品关键字进行搜索并添加药品"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                    @search="drugSearch"
                    @select="drugSelect"
          >
            <a-select-option :class="item.hq ? 'hq-option':'custom-option'" v-for="(item,index) in drugs" :key="item.id" :value="item.id">{{item.text}}</a-select-option>
          </a-select>
        </div>
        <div class="left-span">
          <span>入库单总金额</span>
        </div>
        <div class="right-span">
          <a-button class="custom-primary-btn" type="primary" @click="tempStockIn()" >暂存</a-button> <a-button class="custom-primary-btn" style="margin-left: 10px" @click="saveStockIn()" type="primary">保存</a-button>
        </div>
      </a-row>
      <a-row style="width: 100%; padding: 4px 0px;background-color: #f5f5f5">
        <div style="width: 100%;border-bottom: 1px dashed #bbbbbb"></div>
      </a-row>
      <a-table size="middle" :columns="grid.columns" :loading="grid.loading" :pagination="false"
               rowKey="id" :dataSource="grid.data" :scroll="{ x:'100%', y:520 }" >
        <span slot="qtySlot" slot-scope="text, record, index">
          <a-input-number :min="0.01" v-model="record.stockQty" @change="qtyChange($event,index)"></a-input-number>
        </span>
        <span slot="unitSlot" slot-scope="text, record">
          <a-select v-model="record.stockUnitIndex||0">
            <a-select-option v-for="(item,index) in record.units||[]" :key="item.index" :value="item.index">{{item.name}}</a-select-option>
          </a-select>
        </span>
        <span slot="priceSlot" slot-scope="text, record, index">
          <a-input-number :min="0.01" v-model="record.price" @change="priceChange($event,index)" ></a-input-number>
        </span>
        <span slot="pdateSlot" slot-scope="text, record">
          <a-date-picker valueFormat="YYYY-MM-DD" v-model="record.productionDate"></a-date-picker>
        </span>
        <span slot="vdateSlot" slot-scope="text, record">
          <a-date-picker valueFormat="YYYY-MM-DD" v-model="record.validDate"></a-date-picker>
        </span>
        <span slot="batchNoSlot" slot-scope="text, record">
          <a-input  v-model="record.batchNo"></a-input>
        </span>
        <span slot="operate" slot-scope="text, record, index">
          <a @click="()=>deleteAction(index)">删除</a>
        </span>
      </a-table>
      <a-row style="width: 100%; padding: 12px 0px;display: flex;flex-direction: row;justify-content: center">
        <a-upload :custom-request="handleUpload"
                  :showUploadList="false"
        >
          <a-button class="custom-primary-btn" type="primary">批量导入</a-button>
        </a-upload>
        <a-button style="margin-left: 10px" class="custom-primary-btn" @click="downAction" type="primary">下载导入模板</a-button>
        <a-button style="margin-left: 10px" class="custom-warn-btn" @click="goback" type="normal">返回</a-button>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    name: "PurchaseInBatchCreate",
    data() {
      return {
        loading:false,
        loadTip:'',
        current: {},
        init: {
          types: [{name:'PURCHASE_IN', value:'采购入库'}],
          suppliers:[],
        },
        drugs:[],
        confirmTitle:'',
        record: {
          id:'',
          type : 'PURCHASE_IN',
          docNo: '',
          supplierId:'',
          makeTime: '',
          totalAmount:0,
        },
        grid: {
          loading: false,
          columns: columns,
          data: [],
          selections:[]
        }
      }
    },
    beforeCreate() {
      let data = [{
        text: "首页",
        path: ""
      },{
        text: "云药房",
        path: ""
      },{
        text: "入库管理",
        path: ""
      },{
        text: "采购入库",
        path: ""
      }];
      this.$store.commit('updateBreadcrumb', data);
    },
    mounted() {
      let self = this;
      this.current = JSON.parse(localStorage.getItem("curruser"));
      this.getSuppliers('',100,function (res) {
        self.init.suppliers = res;
      });
      this.getCurrOrgan();
      this.getOrganConfig(this.current.organId, '105',function (res) {
        console.info('105='+res);
        console.info('105='+((res||'') == '1'));
        if((res||'') == '1'){
          self.confirmTitle = '当前系统配置了入库审核流程，在审核完成之前可以继续修改入库登记信息'
        }else{
          self.confirmTitle = '当前系统配置了入库自动审核功能，入库登记后将不能进行登记信息修改，请谨慎操作'
        }
      });
      let id = this.$route.query.id||'';
      if(id!=''){//加载暂存的入库单信息
        this.getStockInDoc(id);
      }else{//新增时，默认增加一条记录
        this.getStockInDocNo();
        this.record.makeTime = this.getCurrDate(new Date());
      }
    },
    methods: {

      /**
       * 获取当前用户所属机构
       */
      getCurrOrgan:function(){
        let self = this;
        this.$axios.get('/api/clinic/' + this.current.organId + '/mine').then(function (res) {
          if(res.msg.flag == 0){
            self.currOrgan = res.biz;
          }
        })
      },

      getStockInDoc:function(id){
        let self = this;
        self.loading = true;
        self.loadTip = '正在加载数据...'
        this.$axios.get('/api/clinic/stockin/'+id).then(function (res) {
          self.loading = false;
          if(res.msg.flag == 0 && res.biz !=null){
            let _makeTime =  (res.biz.makeTime||'').split(' ')
            self.record = {id: res.biz.id, docNo:res.biz.docNo, type:res.biz.type, supplierId : res.biz.supplierId, makeTime: _makeTime.length>0 ? _makeTime[0] : '', totalAmount:res.biz.totalAmount,
              totalQty:res.biz.totalQty, status : res.biz.status};
            if(res.biz.drugs!=null && res.biz.drugs.length>0){
              let drugs = [];
              let drugIndex = 0;
              let unitIndex = 0;
              for(let drug of res.biz.drugs){
                unitIndex = 0;
                drug.units.forEach(function (item,index) {
                  item.index = index;
                  item.unit = item;
                  if(drug.stockUnit == item.name){
                    unitIndex = index;
                  }
                })
                drugs.push({id:new Date().getTime()+'-'+drugIndex, recordId:drug.id, drugId:drug.drugId, name : drug.name, stockQty:drug.qty, price : drug.price, amt : drug.amt, manufacturer:drug.manufacturer,
                  productionDate:drug.productionDate||'', batchNo:drug.batchNo, validDate:drug.validDate, remark:drug.remark, units:drug.units, unitIndex : unitIndex});
                drugIndex++;
              }
              console.info(drugs);
              self.grid.data = drugs;
            }
          }else{
            self.loading = false;
            self.$message.error({content:'加载入库单信息失败', duration:2})
          }
        })
      },

      getStockInDocNo:function(){
        let self = this;
        this.$axios.get('/api/clinic/stockin/docNo').then(function (res) {
          if(res.msg.flag == 0){
            self.record.docNo = res.biz;
          }
        })
      },

      /**
       * 药品搜索事件
       */
      drugSearch:function(value){
        let self = this;
        self.drugs = [];
        if(value==null || value == '' || value.length<2){
          return;
        }
        self.$axios.get('/api/clinic/drug/search',{params:{keyword:value, organId:self.currOrgan.id}}).then(function (res) {
          if(res.msg.flag == 0){
            let list = [];
            for(let item of res.biz||[]){
              item.text = item.hq ? '[总部]' : '[自定义]';
              item.text = item.text +'/' + item.name;
              if(item.alias!=null && item.alias.length>0){
                for(let alia of item.alias){
                  item.text = item.text +'/' + alia;
                }
              }
              if(item.typeName!=null && item.typeName!=''){
                item.text = item.text +'/' + item.typeName;
              }
              if(item.form!=null && item.form!=''){
                item.text = item.text +'/' + item.form;
              }
              if(item.manufacturer!=null && item.manufacturer!=''){
                item.text = item.text +'/' + item.manufacturer;
              }

              list.push(item);
            }
            self.drugs = list;
          }
        })
      },

      /**
       * 药品选中事件
       */
      drugSelect:function(id){
        let self = this;
        for(let item of this.drugs){
          if(id == item.id){
            let _units = [];
            let index = 0;
            for(let unit of item.units){
              _units.push({index : index, name:unit.name, rate:unit.rate});
              index++;
            }
            self.grid.data.push({id:new Date().getTime(), drugId:item.id, name:item.name,spec:item.spec,drug:item, typeName:item.typeName, unitIndex:0, units:_units,
              manufacturer:item.manufacturer});
            break;
          }
        }
        this.drugs = [];
      },

      /**
       * 删除某一行
       * @param index
       */
      deleteAction:function(index){
        this.grid.data.splice(index,1);
      },

      qtyChange:function (e,index) {
        let qty = e;
        let drug = this.grid.data[index];
        if(drug.price!=null && drug.price!=undefined && drug.price!=''){
          drug.amt = qty * drug.price;
          this.grid.data[index] = drug;
          this.$forceUpdate();
        }
      },

      priceChange:function (e,index) {
        let price = e;
        let drug = this.grid.data[index];
        if(drug.stockQty!=null && drug.stockQty!=undefined && drug.stockQty!=''){
          drug.amt = price * drug.stockQty;
          this.grid.data[index] = drug;
          this.$forceUpdate();
        }
      },

      /**
       * 下载excel模板
       */
      downAction:function(){
        let self = this;
        this.loadTip = '正在下载模板...'
        this.loading = true;
        let token = null;
        if (localStorage.token) {
          token = JSON.parse(localStorage.token);
        }
        axios({
          baseURL:self.$axios.baseURL,
          url:'/api/clinic/stockin/excel/export',
          method:'POST',
          responseType:'blob',
          headers:{
            'Authorization' : "Bearer " + token.access_token
          },
          data:{}
        }).then(function (res) {
          self.loading = false;
          let content = res;
          let blob = new Blob([content]);
          if('download' in document.createElement('a')){
            let link = document.createElement('a');
            link.download = '药品入库导入模板.xls';
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            document.body.append(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          }else{
            navigator.msSaveBlob(blob);
          }
        }).catch(function (err) {
          console.info(err);
          self.loading = false;
          self.$message.error({content:'下载模板失败'});
        })

      },

      /**
       * 导入动作
       */
      handleUpload:function(src){
        const self = this;
        const isLt = src.file.size / 1024 / 1024 < 10;
        if(!isLt){
          self.$message.error({content: '图片文件大小少于10M.', duration: 2});
          return false;
        }
        let params = new FormData();
        params.append("file", src.file);
        this.loadTip='正在解析数据....';
        this.loading = true;
        this.$axios.post('/api/clinic/stockin/excel/import', params, {headers: {
            'Content-Type': 'multipart/form-data'
          },timeout: 1000 * 60 * 15}).then(function(res){
          console.info(res)
          self.loading = false;
          if(res.msg.flag == 0){
            self.$message.success({content:'解析成功'});
            console.info(res.biz)
            let drugs = [];
            let drugIndex = 0;
            let unitIndex = 0;
            for(let drug of res.biz||[]){
              unitIndex = 0;
              drug.units.forEach(function (item,index) {
                item.index = index;
                item.unit = item;
                if(drug.stockUnit == item.name){
                  unitIndex = index;
                }
              })

              drugs.push({id:new Date().getTime()+'-'+drugIndex, drugId:drug.drugId, name : drug.name, stockQty:drug.stockQty, price : drug.price, amt : drug.amt, manufacturer:drug.manufacturer,
                productionDate:drug.productionDate||'', batchNo:drug.batchNo, validDate:drug.validDate, units:drug.units, unitIndex : unitIndex});
              drugIndex++;
            }

            self.grid.data = drugs;
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(){
          self.loading = false;
        });

        return false;
      },


      /**
       * 暂存入库单
       */
      tempStockIn:function () {
        this.submitStockIn('1');
      },
      /**
       * 保存入库单
       */
      saveStockIn:function () {
        this.submitStockIn('2');
      },

      submitStockIn:function (type) {// type : 1为暂存  2为保存
        let self = this;

        let serverUrl = '/api/clinic/stockin/registered';
        let action='保存';
        if(type == '1'){
          serverUrl = '/api/clinic/stockin/register';
          action ='暂存';
        }
        let record = this.record;
        if(record.supplierId == null || record.supplierId == ''){
          self.$message.error({content:'请选择供应商', duration:2});
          return;
        }
        if(record.makeTime == null || record.makeTime == ''){
          self.$message.error({content:'请选择制单日期', duration:2});
          return;
        }

        let params = {id:self.record.id||'', type:record.type||'',supplierId:record.supplierId||'', makeTime:record.makeTime+' 00:00:00'};

        let items=[];

        if(undefined != self.grid.data && null != self.grid.data && self.grid.data.length > 0){
          let stockUnit = null;
          for(let item of self.grid.data){
            if(item.drugId == null || item.drugId == undefined || item.drugId == ''){
              self.$message.error({content:'请选择入库药品', duration:2});
              return;
            }
            if(item.units==null || item.units == undefined || item.units.length == 0){
              self.$message.error({content:'入库药品单位不存在', duration:2});
              return;
            }
            stockUnit = {name:item.units[item.unitIndex].name, rate:item.units[item.unitIndex].rate };

            if(item.stockQty==null || item.stockQty == undefined || item.stockQty == 0){
              self.$message.error({content:'请输入入库数量', duration:2});
              return;
            }

            if(item.stockQty==null || item.stockQty == undefined || item.stockQty == 0){
              self.$message.error({content:'请输入药品['+item.name+']的入库数量', duration:2});
              return;
            }

            if(item.price==null || item.price == undefined){
              self.$message.error({content:'请输入药品['+item.name+']的采购单价', duration:2});
              return;
            }

            //if(item.productionDate==null || item.productionDate == undefined || item.productionDate == ''){
            //  self.$message.error({content:'请输入药品['+item.name+']的生产日期', duration:2});
            //  return;
            //}

            if(item.validDate==null || item.validDate == undefined || item.validDate == ''){
              self.$message.error({content:'请输入药品['+item.name+']的有效日期', duration:2});
              return;
            }

            //if(item.batchNo==null || item.batchNo == undefined || item.batchNo == ''){
            //  self.$message.error({content:'请输入药品['+item.name+']的生产批号', duration:2});
            //  return;
            //}

            items.push({ drugId:item.drugId, stockQty:item.stockQty, stockUnit: stockUnit, price : item.price, amt:item.amt,
              productionDate:item.productionDate||'', validDate:item.validDate||'', batchNo:item.batchNo||''});

          }
        }
        console.info(params);
        if(items.length == 0){
          self.$message.error({content:'请至少录入一条药品入库信息', duration:2});
          return;
        }
        params.drugs = items;



        self.$confirm({
          title: self.confirmTitle,
          okText:'入库登记',
          onOk() {
            self.loadTip='正在'+action+'入库单信息,请稍候...';
            self.loading = true;
            console.info(params);
            self.$axios.post(serverUrl, params).then(function(res){
              console.info(res);
              self.loading = false;
              if(res.msg.flag == 0){
                self.$message.success({content: '入库单'+action+'成功.', duration: 2});
                if(type == '2'){
                  self.data = [];
                  self.$router.go(-1);
                }else{
                  self.record.id = res.biz;
                  self.$confirm({
                    title: '是否继续修改该入库单',
                    okText:'继续',
                    onOk() {
                    },
                    onCancel(){
                      self.$router.go(-1);
                    }
                  })
                }

              }else{
                self.$message.error({content: res.msg.message, duration: 2});
              }
            },function(res){
              console.error(res)
              self.loading = false;
            });
          },
        });
      },

      goback:function () {
        this.$router.go(-1)
      }

    }
  }

  let columns = [
    {
      title: '序号',
      dataIndex: 'id',
      align: 'center',
      customRender: (text, record, index) => {
        return index+1;
      },
      width: 80
    },
    {
      title: '药品名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '药品规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 120
    },
    {
      title: '生产厂家',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
      align: 'center',
      ellipsis: true,
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '数量',
      dataIndex: 'stockQty',
      key: 'stockQty',
      align: 'center',
      scopedSlots: { customRender: 'qtySlot'},
      width: 120
    },
    {
      title: '单位',
      dataIndex: 'stockUnit',
      key: 'stockUnit',
      align: 'center',
      scopedSlots: { customRender: 'unitSlot'},
      width: 120
    },
    {
      title: '采购单价',
      dataIndex: 'price',
      key: 'price',
      align: 'center',
      scopedSlots: { customRender: 'priceSlot'},
      width: 120
    },
    {
      title: '采购金额',
      dataIndex: 'amt',
      key: 'amt',
      align: 'center',
      scopedSlots: { customRender: 'amtSlot'},
      width: 120
    },
    {
      title: '生产日期',
      dataIndex: 'productionDate',
      key: 'productionDate',
      align: 'center',
      scopedSlots: { customRender: 'pdateSlot'},
      width: 130
    },
    {
      title: '有效期',
      dataIndex: 'validDate',
      key: 'validDate',
      align: 'center',
      scopedSlots: { customRender: 'vdateSlot'},
      width: 130
    },
    {
      title: '生产批号',
      dataIndex: 'batchNo',
      key: 'batchNo',
      align: 'center',
      scopedSlots: { customRender: 'batchNoSlot'},
      width: 160
    },
    {
      title: '操作',
      key: 'operate',
      align: 'center',
      fixed: 'right',
      width: 140,
      scopedSlots: { customRender: 'operate'}
    }

  ]
</script>

<style>
  .form-row{
    width: 100%;
    padding: 8px 0px 4px 0px;
    background-color: #f5f5f5
  }
  .form-row .left-span{
    float: left;
    margin-left: 24px;
    line-height: 32px;
    color: rgba(0, 0, 0, 0.85);
  }
  .form-row .right-span{
    float: right;
    margin-right: 24px;
    line-height: 32px;
  }
  .form-row .btn-form{
    margin-left: 10px;
  }

  .custom-option{
    color: #9e8585;
  }

  .hq-option{
    color: #333333;
  }

</style>
